import type React from 'react'
import { Suspense } from 'react'
import { Global, css } from '@emotion/react'
import MobileWrapper from 'consumer-mobile-web/components/MobileWrapper'
import Header from './Header'
import Survey from './Survey'

const styles = css`
  html {
    font-size: 20px;
  }
`

const SurveyContainer: React.FC = () => {
  return (
    <MobileWrapper>
      <Global styles={styles} />
      <Suspense fallback={null}>
        <Header />
        <main>
          <Survey />
        </main>
      </Suspense>
    </MobileWrapper>
  )
}

export default SurveyContainer
